<div class="modal-content" style="max-width: none !important;">
    <div class="modal-head d-flex justify-content-end">
        <button type="button" class="close m-2" style="border: none; background-color: transparent; font-size: 1rem;" (click)="fecharModal()" aria-hidden="true"><b>X</b></button>
    </div>
    <div class="modal-body" id="tblExport" id="print-section">
        <table cellspacing="0" style="font-family: calibri; font-size: 10px; width: 100%">
            <tr>
                <td>Data do Vencimento</td>
                <td>Valor</td>
                <td>Parcela</td>
                <td>Nosso Número</td>
                <td>Data Processamento</td>
                <td>Status</td>
            </tr>
            <tr *ngFor="let boleto of boletos">
                <td style='text-align: start'>{{boleto.Vencimento}}</td>
                <td style='text-align: start'>{{boleto.Valor}}</td>
                <td style='text-align: start'>{{boleto.Parcela}}</td>
                <td style='text-align: start'>{{boleto.NossoNumero}}</td>
                <td style='text-align: start'>{{boleto.DataProcessamento | date : 'dd/MM/yyyy HH:mm:ss'}}</td>
                <td style='text-align: start'>{{boleto.Status}}</td>
            </tr>
        </table>
    </div>
</div>